/** Column widths shared by the header and every file row, so both stay aligned. */
export const ARCHIVE_COLUMNS = {
	client: "hidden w-44 shrink-0 truncate md:block",
	job: "hidden w-36 shrink-0 truncate sm:block",
	kind: "w-56 shrink-0 truncate",
	date: "w-24 shrink-0 text-right",
	action: "w-7 shrink-0",
};

interface ArchiveFileTableHeaderProps {
	showClient: boolean;
	showJobContext: boolean;
}

export const ArchiveFileTableHeader: React.FC<ArchiveFileTableHeaderProps> = ({
	showClient,
	showJobContext,
}) => {
	return (
		<div className="sticky top-0 z-10 flex items-center gap-3 border-b border-gray-200 bg-gray-50 px-3 py-2 text-xs font-medium uppercase tracking-wide text-gray-500">
			<span className="w-4 shrink-0" />
			<span className="min-w-0 flex-1">Name</span>
			{showClient && (
				<span className={ARCHIVE_COLUMNS.client}>Auftraggeber</span>
			)}
			{showJobContext && (
				<span className={ARCHIVE_COLUMNS.job}>Auftrag</span>
			)}
			<span className={ARCHIVE_COLUMNS.kind}>Art</span>
			<span className={ARCHIVE_COLUMNS.date}>Datum</span>
			<span className={ARCHIVE_COLUMNS.action} />
		</div>
	);
};
